const articleAnimationShowcase = {
    "key": "w05",
    "title": "Animation Showcase",
    "skills": "Graphic Design | Animation | Scripting",
    "date": "2015 - Present",
    "path": "animations",
    "graphic": "anim-bg.jpg",
    "content": [
      {
        "component": "Title",
        "content": "Animation Showcase"
      },
      {
        "component": "Subheading",
        "design": "centered",
        "content": "Graphic Design | Animation | Scripting"
      },
      {
        "component": "Body",
        "design": "centered",
        "content": "This collection of animation projects shows my fun, light-hearted, punchy style for motion graphics creation. I enjoy using various tools like Photoshop, AfterEffects, Resolve, and CSS to build unique and engaging visual experiences for brands and products."
      },
      {
        "component": "Subheading",
        "content": "NBD Animated Logo"
      },
      {
        "component": "Image",
        "source": "../videos/animations/UI-Animation-2.gif",
        "alt": "Nick Burgher Design - Animated Logo"
      },
      {
        "component": "Body",
        "content": "Created with love by hand in Photoshop 7.0 and ImageReady<br/>built frame-by-frame!",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "Tech Addiction Quiz Social Ad"
      },
      {
        "component": "Video",
        "source": "animations/TechlessQuiz_Ad_compressed.mov"
      },
      {
        "component": "Body",
        "content": "Taking one of the illustrations created for the <a href=\"./tech-addiction-quiz\">Tech Addiction Quiz</a>, I animated our \"smartphone disciple\" character and added supporting text for a Facebook Ad.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "Techless Talks Bumper"
      },
      {
        "component": "Video",
        "source": "animations/TTBumper_compressed.mov",
        "autoplay": "autoplay"
      },
      {
        "component": "Body",
        "content": "This was an intro for the \"Techless Talks\" video series. I was involved in the full production of this sequence, including visual art direction, pacing, animation, and audio selection.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "Animated Techless Logo"
      },
      {
        "component": "Video",
        "source": "animations/TechlessAnimatedLogo_compressed.mov"
      },
      {
        "component": "Body",
        "content": "Originally built for use within a slide presentation with the Sexual Intergrity Leaderhsip Summit, this version of the Techless logo was animated from line data and utilized physics-based keyframing in to give it life.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "Dexter Solutions Logo Animation"
      },
      {
        "component": "YoutubeEmbed",
        "embedId": "K-C-Co1u7sI"
      },
      {
        "component": "Body",
        "content": "Animation for Dexter Solutions branded videos. Built with AfterEffects.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "Status Auto Detailing"
      },
      {
        "component": "YoutubeEmbed",
        "embedId": "9ywCsmroOgs"
      },
      {
        "component": "Body",
        "content": "Status Auto Detailing in Springfield MO. Animation was created in AfterEffects using complex mask groups, smooth keyframe interpolation, expressions, and 3D rotation.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "\"Sellable Units\" Stop Motion"
      },
      {
        "component": "YoutubeEmbed",
        "embedId": "xIras8B23Rs",
        "startAt": "12"
      },
      {
        "component": "Body",
        "content": "Internal initiative, frame animation created with Nikon D750 and a lot of chocolate. Had to be created in reverse order because the video wraps each of the items into their wrappers. Fun fun.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "SVG Web Animations"
      },
      {
        "component": "Video",
        "source": "animations/SVGAnim_compressed.mov"
      },
      {
        "component": "Body",
        "content": "This clever SVG animation was designed in Figma first, then exported to code. With CSS, I was able to animate specific parts of the illustration in order to have our character move within the space. Building an animation in this way is a much better alternative to GIFs and embedded videos for web implementations because the file size is so much smaller and the resolution infinitely scalable.",
        "design": "centered caption"
      },
      {
        "component": "Subheading",
        "content": "\"3 Phones\" Animation"
      },
      {
        "component": "Video",
        "source": "animations/3Phones_Anim_compressed1080.mov"
      },
      {
        "component": "Body",
        "content": "Created for a website header video, this looping animation was designed to loop continuously on the Techless homepage to quickly showcase the Wisephone product for first-time visitors. With AfterEffects, I was able to chain the animation of one object to the others and set an offset value so that elements moved in a wave-like pattern.",
        "design": "centered caption"
      }
    ]
  }

export default articleAnimationShowcase;